import {
  ProjectVersionActionTypes,
  IDeleteProjectVersionsPayload,
  IDeleteProjectVersionsSuccessPayload,
  IUpdateProjectVersionTitlePayload,
  IUpdateProjectVersionTitleSuccessPayload
} from './types'

export const deleteProjectVersions = (payload: IDeleteProjectVersionsPayload) => ({
  type: ProjectVersionActionTypes.DELETE_PROJECT_VERSIONS,
  payload,
})

export const deleteProjectVersionsFailure = () => ({
  type: ProjectVersionActionTypes.DELETE_PROJECT_VERSIONS_FAILURE,
})

export const deleteProjectVersionsSuccess = (payload: IDeleteProjectVersionsSuccessPayload) => ({
  type: ProjectVersionActionTypes.DELETE_PROJECT_VERSIONS_SUCCESS,
  payload
})

export const updateProjectVersionTitle = (payload: IUpdateProjectVersionTitlePayload) => ({
  type: ProjectVersionActionTypes.UPDATE_PROJECT_VERSION_TITLE,
  payload
})

export const updateProjectVersionTitleSuccess = (payload: IUpdateProjectVersionTitleSuccessPayload) => ({
  type: ProjectVersionActionTypes.UPDATE_PROJECT_VERSION_TITLE_SUCCESS,
  payload
})

export const updateProjectVersionTitleFailure = () => ({
  type: ProjectVersionActionTypes.UPDATE_PROJECT_VERSION_TITLE_FAILURE,
})
